export * from './geracaoarquivocnab-component';